import { Routes } from '@angular/router';
import { authenticatedRouteGuards, canActivateUser } from '@shared/guard/guard';
import { PageKey } from '@shared/services/page/models/page.key';

export const collaboratorRoute: Routes = [
  {
    path: 'collaborators',
    loadComponent: () => import('@collaborator/pages/list/list.component').then(m => m.ListComponent),
    canActivate: [...authenticatedRouteGuards, canActivateUser],
    data: {
      title: 'Colaboradores',
      key: PageKey.COLLABORATORS
    }
  }
];
